import React from 'react';
import { createRoot } from "react-dom/client";
import './index.css';
import App from './App';

import { Provider } from "react-redux";
import { HashRouter as Router } from 'react-router-dom';

import * as backendModule from "./modules/backendModule";
import allReducers from "./reducers";
import { createStore } from 'redux';
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";

let store = createStore(allReducers, composeWithDevTools());
backendModule.setStore(store);

const rootElem = createRoot(document.querySelector("#root"));
rootElem.render(<Provider store={store}>
    <Router>
        <App />
    </Router>
</Provider>);